export const iconTypes = {
	access: ['mdb'],
	air: ['air'],
	audio: [
		'aa',
		'aac',
		'aax',
		'aif',
		'aiff',
		'alac',
		'au',
		'flac',
		'iff',
		'm3u',
		'm4a',
		'm4p',
		'mid',
		'mogg',
		'mp2',
		'mp3',
		'mpa',
		'oga',
		'ogg',
		'ra',
		'wav',
		'wma',
	],
	cad: ['dwg'],
	code: [
		'aspx',
		'bat',
		'c',
		'class',
		'cpp',
		'cs',
		'css',
		'cxx',
		'exe',
		'h',
		'htm',
		'html',
		'hxx',
		'java',
		'js',
		'jsx',
		'ts',
		'tsx',
		'py',
		'xml',
	],
	diskCatalogMaker: ['dcm'],
	email: ['eml', 'emlx', 'msg'],
	encapsulatedPostScript: ['eps', 'epsf', 'epsi'],
	excel: ['csv', 'excel', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx', 'xlw'],
	flash: ['as', 'asc', 'fla', 'flash', 'jsfl', 'swf'],
	illustrator: ['ai'],
	image: ['bmp', 'exif', 'gif', 'jpeg', 'jpg', 'pdn', 'png', 'raw', 'svg', 'tif', 'tiff'],
	indesign: ['indb', 'indd', 'indl', 'indt', 'inx'],
	keynote: ['key'],
	rivet: ['rvt'],
	navisworks: ['nwd', 'nwf'],
	noteworthyComposer: ['nwc', 'nwctxt'],
	numbers: ['numbers'],
	onenote: ['one', 'onea', 'onetoc', 'onetoc2', 'onetmp', 'onepkg'],
	pages: ['pages'],
	pdf: ['pdf'],
	photoshop: ['psd', 'ps'],
	powerpoint: [
		'pot',
		'potm',
		'ppam',
		'pps',
		'ppsx',
		'ppt',
		'pptm',
		'pptx',
		'sldm',
		'sldx',
	],
	project: ['mpd', 'mpp', 'mpt', 'mpx'],
	publisher: ['pub'],
	quickbooksBackup: ['qbb'],
	quickbooksWindows: ['qbw'],
	sketch: ['sketch'],
	text: ['log', 'rtf', 'text', 'txt', 'xml'],
	video: ['mov', 'mp4', 'm4v', 'wmv', 'mkv', 'avi', 'flv', '3gp', '3g2', 'mpg', 'webm'],
	visio: ['vdx', 'vsdm', 'vsdx', 'vsd', 'vss', 'vst', 'vsx', 'vtx'],
	word: ['doc', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'rtf'],
	zip: ['7z', 'bz2', 'gz', 'rar', 'zip', 'zipx'],
};

export function getIconTypeByExtension(extension: string) {
	const category = Object.keys(iconTypes).find(key => {
		return (iconTypes as { [key: string]: string[] })[key].includes(extension);
	});

	return category as keyof typeof iconTypes;
}
